import React, { Component } from 'react'
import { Button, Loading, InfiniteScroll, Popup, Selector, FloatingBubble, Avatar } from 'antd-mobile'
import { FilterOutline, DownFill, LeftOutline } from 'antd-mobile-icons'

import intl from 'react-intl-universal'
import qs from 'qs'

import NavigationBar from '../../components/NavigationBar'
// import CurrencySymbol from '../../components/CurrencySymbol'
import SelectLanguage from '../../components/SelectLanguage'

import { getProductList, getDictData, getCountryCode, getProductRuleInfo, getProductRuleTypes } from '../../model/tour'
import { setDictData, setCountryCodeStore, setFromParamStore } from '../../utils/storage/tour'
import { setPageParamSession, getPageParamSession, setFromView } from '../../utils/session/tour'
import { getCurrencySymbol } from '../../data/currency'

import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
import ActivityDuration from '../../components/ActivityDuration'



import simon from '../../assets/images/demo/simon_1.jpeg'
// import island from '../../assets/images/demo/island_1.webp'

import defImg from '../../assets/images/def_img_food.png'
import hlLogo from '../../assets/images/icon/word-logo.png'

import './index.less'
const InfiniteScrollContent = ({ hasMore }) => {
  return (
    <>
      {hasMore ? (
        <>
          <span>Loading</span>
          <Loading />
        </>
      ) : (
        <span>--- No more data ---</span>
      )}
    </>
  )
}

export default class index extends Component {
  state = {
    hasMore: true,
    listParam: {
      pageNow: 1,
      pageSize: 10,
      onlineStatus: 1
    },
    list: [],
    imgHeight: 0,
    ruleText: '',
    filterVisible: false,
    productTypeArr: [],
    typeCheckedArr: [],
    tmpArr: []
  }
  render() {

    const { hasMore, list, imgHeight, ruleText, filterVisible, productTypeArr, typeCheckedArr } = this.state

    const paramSession = getPageParamSession()
    const isShowBubble = paramSession && paramSession.back !== ''

    return (
      <div className='home-wrap' ref={e => this.wrarRef = e}>
        <header className='header'>
          <div className='pos_rel'>
            {
              isShowBubble
                ?
                <div className='filter-btn jm-flex'
                  onClick={this.returnFromWebsite}>
                  <LeftOutline fontSize={18} />
                </div>
                : null
            }

            <div className='title ellips1'> {ruleText || 'Experiences in Phuket'} </div>
            {
              isShowBubble ? null : <div className='lan-box'><SelectLanguage /></div>
            }

          </div>
        </header>
        {
          productTypeArr.length > 0
            ?
            <div className='pt-wrap jm-flex' style={{ padding: '10px 10px 2px' }}>
              <div className='jm-flex-item pt-main'>
                {
                  productTypeArr.map((item, index) => {
                    const isChecked = typeCheckedArr.some(o => item.value === o)
                    return <div
                      className={`pt-item ${isChecked ? 'current' : ''}`}
                      key={index}
                      onClick={e => this.checkProductTypeItem(isChecked, item)}>
                      <div>{item.label}</div>
                    </div>
                  })
                }
              </div>
              <div
                className='pt-right'
                onClick={() => this.setState({ filterVisible: true })}>
                <DownFill />
              </div>
            </div>
            :
            null
        }


        <div className='pannel' style={{ paddingBottom: 30 }}>
          <ul className='pd-list'>
            {
              list.map((item, index) => {
                const { productImageList, productPrices = [] } = item
                let img = defImg
                if (productImageList && productImageList.length > 0) {
                  img = productImageList[0].url
                }
                let startPrice = 0,
                  currency = ''
                if (productPrices && productPrices.length > 0) {
                  const sortArr = productPrices.filter(item => item.totalPrice !== null).sort((a, b) => a.totalPrice - b.totalPrice)
                  if (sortArr && sortArr.length > 0) {
                    startPrice = sortArr[0].totalPrice
                    currency = sortArr[0].currency
                  }

                }
                const cCode = getCurrencySymbol(currency)

                return (
                  <li key={index}
                    className='pd-item'
                    onClick={e => this.toProductDetail(item)}>
                    <img
                      src={img}
                      alt="product"
                      style={imgHeight > 200 ? { height: imgHeight } : null}
                      onError={e => {
                        e.target.onerror = null;
                        e.target.src = defImg;
                      }} />
                    <div className='pd-content'>
                      <div className='fs-12 text-gray'><b><ActivityDuration item={item.productPlayInfoActivity} /></b></div>

                      <div className='pd-name'><b>{item.productName}</b></div>
                      {
                        // item.destinationName
                        //   ?
                        //   <div className='fs-12 text-gray'><b>{intl.get('destination').d('目的地')}: {item.destinationName}</b></div>
                        //   : null
                      }
                      <div className='pd-price'>{intl.get('from_price_currency', { currency: cCode, price: startPrice }).d(`${cCode}${startPrice || ''}起`)}</div>
                    </div>
                  </li>
                )
              })
            }
            <li className='pd-item hide' onClick={e => this.toProductDetail()}>
              <img src={simon} alt="product" />
              <div className='pd-content'>
                <div className='fs-12 text-gray'><b>ABOUT 2 HOUR</b></div>
                <div className='pd-name'><b>Simon Cabaret Phuket</b></div>
                <div className='pd-price'>from THB788</div>
              </div>
            </li>
          </ul>
          <InfiniteScroll loadMore={this.loadProductList} hasMore={hasMore} >
            <InfiniteScrollContent hasMore={hasMore} />
          </InfiniteScroll>
        </div>
        <br />
        <br />
        <NavigationBar callback={this.reloadProducts} />
        {
          // isShowBubble
          //   ?
          //   <FloatingBubble
          //     axis='xy'
          //     style={{
          //       '--background': '#607D8B',
          //       '--initial-position-bottom': '384px',
          //       '--initial-position-right': '10px',
          //       '--edge-distance': '24px',
          //     }}>
          //     <div onClick={this.returnFromWebsite}>
          //       <Avatar fit='contain' src={hlLogo} />
          //     </div>
          //   </FloatingBubble> : null
        }
        <Popup
          visible={filterVisible}
          position='bottom'
          onClose={() => this.setState({ filterVisible: false })}
          onMaskClick={() => this.setState({ filterVisible: false })}>

          <div style={{ padding: 12 }}>
            {/* <div style={{ marginBottom: 10 }}><Checkbox onChange={this.checkAllTypes}>{intl.get('aaa').d('全选')}</Checkbox></div> */}
            {
              filterVisible ? <Selector
                columns={3}
                options={productTypeArr}
                multiple
                defaultValue={typeCheckedArr}
                onChange={(arr, extend) => {
                  console.log(arr, extend.items)
                  this.setState({ tmpArr: arr })
                }} /> : null
            }

          </div>
          <div style={{ padding: '0 12px 12px' }}>
            <Button color='primary' block onClick={() => {
              const { tmpArr } = this.state
              this.setState({
                filterVisible: false,
                typeCheckedArr: [...tmpArr]
              },
                () => {
                  this.reloadProducts()
                })
            }}>
              {intl.get('confirm').d('确定')}
            </Button>
          </div>
        </Popup>
      </div>

    )
  }
  componentDidMount() {
    //this.loadProductList()

    this.setLocationParam()

    this.getDictionaryData()

    this.getCountryCodes()

    this.loadProductRule()

    this.loadProductTypes()

    this.resizeUpdate()
    this.setResizeTimeout = null
    window.addEventListener('resize', this.resizeUpdate);
  }

  componentWillUnmount() {
    console.log('will unmount')
    window.removeEventListener('resize', this.resizeUpdate)
  }

  toProductDetail = (item) => {
    // this.addBehaviorAction({behaviorType:150500,value1:item.id})
    addBehaviorsRecord({ value2: item.id, behaviorType: 150700 })

    setFromView('home_list')
    this.props.history.push(`/product?id=${item.id}`, { from: window.location.hash })
  }

  loadProductList = async () => {


    const { listParam, hasMore, typeCheckedArr = [] } = this.state
    const { pageNow } = listParam
    if (!hasMore) return false

    try {
      const param = getPageParamSession() || {}
      if (param.rule) {
        listParam.productRuleId = param.rule
      }
      if (param.partner) {
        listParam.partnerId = param.partner
      }
      listParam.productTypeList = typeCheckedArr.join()

      const data = await getProductList(listParam)
      const { list, total: rowCount, pageSize } = data
      if (rowCount === 0) {
        this.setState({ hasMore: false })
        return
      }

      const pageCount = Math.ceil(rowCount / pageSize)

      const keepLoad = pageNow !== pageCount
      const newPageNo = keepLoad ? pageNow + 1 : pageNow

      this.setState(state => ({
        list: [...state.list, ...list],
        hasMore: keepLoad,
        listParam: { ...state.listParam, pageNow: newPageNo }
      }))

      console.log(data)

    } catch (ex) {
      console.log(ex)
      this.setState({ hasMore: false })

    }

  }

  resizeUpdate = () => {
    if (this.setResizeTimeout) {
      clearTimeout(this.setResizeTimeout)
    }
    this.setResizeTimeout = setTimeout(() => {
      const width = this.wrarRef.offsetWidth - 20;
      const height = parseInt(width / 1.66)

      this.setState({ imgHeight: height })
      // console.log(width, height)
    }, 100)

  }

  getDictionaryData = () => {
    getDictData({}, true).then(data => {
      console.log(data)
      setDictData(data)
    }).catch(msg => {
      console.log(msg)
    })
  }

  getCountryCodes = () => {

    getCountryCode({}, true).then(data => {
      console.log(data)
      setCountryCodeStore(data)
    }).catch(msg => {
      console.log(msg)
    })

  }

  setLocationParam = () => {
    const { location = {} } = this.props
    const search = location.search.replace('?', '')
    const param = qs.parse(search) || {}

    const oriData = getPageParamSession()

    const referrer = document.referrer || ''
    const fromOtherSite = ((referrer.indexOf('jimutour.com') > -1 || referrer.indexOf('triplusx.com') > -1) || (window.location.hostname === 'localhost'))
    if (/*fromOtherSite && //*/Object.keys(param).length > 0) {
      const obj = {
        hotel: param.hotel || '',
        member: param.member || '',
        room: param.room || '',
        partner: param.partner,
        rule: param.rule,
        from: param.from,
        back: param.back,
        livechat: param.livechat ? parseInt(param.livechat): null
      }
      setPageParamSession(obj)
    }
  }

  reloadProducts = () => {

    this.setState(state => ({
      list: [],
      hasMore: true,
      listParam: { ...state.listParam, pageNow: 1 }
    }))

  }

  loadProductRule = () => {
    const param = getPageParamSession() || {}
    getProductRuleInfo({ productRuleId: param.rule || '' })
      .then(result => {
        let name = ''
        if (result) {
          name = result.ruleName
        }

        this.setState({ ruleText: name })

      }).catch(ex => {
        console.log(ex)
      })

  }

  loadProductTypes = () => {
    const listParam = {}
    const param = getPageParamSession() || {}
    if (param.rule) {
      listParam.productRuleId = param.rule
    }
    if (param.partner) {
      listParam.partnerId = param.partner
    }

    getProductRuleTypes(listParam)
      .then(result => {
        console.log(result)
        const arr = result?.map(item => {
          return {
            label: item.typeName,
            value: item.type
          }
        })
        this.setState({ productTypeArr: arr || [] })

      }).catch(ex => {
        console.log(ex)
      })

  }

  checkAllTypes = (value) => {
    const { productTypeArr } = this.state
    let arr = []
    if (value) {
      arr = productTypeArr.map(item => item.value)
    }

    this.setState({ typeCheckedArr: arr })

  }

  returnFromWebsite = () => {
    let { back = '' } = getPageParamSession() || {}
    if (back !== '') {
      if (back.indexOf('#menu') > -1) {
        back += '&source=tour'
      }
      window.location.href = back
    }
  }

  checkProductTypeItem = (isCurrent, item) => {
    const { typeCheckedArr } = this.state
    let arr = []
    if (isCurrent) {
      arr = typeCheckedArr.filter(o => o !== item.value)
    } else {
      arr = [...typeCheckedArr]
      arr.push(item.value)
    }

    this.setState({ typeCheckedArr: arr }, () => {
      this.reloadProducts()
    })

  }


}

